import { memo } from "react";

import type { HotelApplicationDataQueryQuery } from "@/lib/gql/__generated__/graphql";

import { CancellationMain } from "./components";
import { useActions } from "./hooks";
import { FeatureIslandContainer, FeatureIslandHeader, FeatureIslandMain } from "../../_layouts";
import { useInitialized } from "../model/use-case";

type Props = {
	hotelApplicationData: HotelApplicationDataQueryQuery;
};

export const CancellationPresenter = memo(({ hotelApplicationData }: Props) => {
	const { queryData, viewModel, onSetViewModel, onCancellation } = useInitialized({ hotelApplicationData });

	const {
		handleChangeReasonOfChurnInfo,
		handleChangeCommentOfChurnInfo,
		handleChangeAlternativeSystemProductName,
		handleChangeAlternativeSystemReason,
		handleClickCancellation,
	} = useActions(viewModel, onSetViewModel, onCancellation);

	return (
		<FeatureIslandContainer>
			<FeatureIslandHeader title="解約" />
			<FeatureIslandMain>
				<CancellationMain
					validDtEndBasic={queryData.validDtEndBasic || undefined}
					isStopRecurringBasicBilling={queryData.isStopRecurringBasicBilling}
					churnInfo={viewModel.churnInfo}
					hasError={viewModel.hasError}
					onChangeReasonOfChurnInfo={handleChangeReasonOfChurnInfo}
					onChangeCommentOfChurnInfo={handleChangeCommentOfChurnInfo}
					onChangeAlternativeSystemProductName={handleChangeAlternativeSystemProductName}
					onChangeAlternativeSystemReason={handleChangeAlternativeSystemReason}
					onClickCancellation={handleClickCancellation}
				/>
			</FeatureIslandMain>
		</FeatureIslandContainer>
	);
});
